import React from "react";
import Cookies from "universal-cookie";
import Button from '@mui/material/Button';
import '../../../App.css';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PasswordIcon from '@mui/icons-material/Password';
import CustomTestField from "../Components/CustomTextField";


const cookies = new Cookies();
class VisaMasterPayment extends React.Component {
    render() {
        const goBack = () => {
            if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '1')
                window.location.href = "/doctor-dashboard"
            else
                window.location.href = "/"
        }

        if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '1') {
            return (
                <div className="visa-master-payment-dashboard-div" style={{ color: '#2E5266FF' }}>
                    
                    <div style={{
                        width:'80%',
                        backgroundColor:'#F8F8F8',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        justifyContent:'flex-start',
                        borderTopLeftRadius:20,
                        borderTopRightRadius:20,
                        borderBottomLeftRadius:15,
                        borderBottomRightRadius:15,
                        borderStyle: 'solid',
                        borderWidth: '0px 2px 2px 2px',
                        borderColor:'#2E5266',
                        marginTop:100
                    }}>
                        <div style={{ 
                    
                            border: '5px solid #2E5266',
                            // borderRadius:20,
                            borderTopLeftRadius:15,
                            borderTopRightRadius:15,
                            background: '#2E5266',
                            height: '24px',
                            marginTop:0,
                           
                            width:'100.1%'
                            }}>

                        </div>

                        <h2 style={{marginTop:30}}>بوابة الدفع الالكتروني</h2>
                        <h4 style={{marginTop:10,marginBottom:30, direction:'ltr'}}> ! يرجى ادخال المعلومات بشكل صحيح لتنفيذ عملية الدفع بنجاح</h4>
                        <div style={{display:'flex', flexDirection:'row',width:'100%',alignItems:'flex-start',justifyContent:'center'}}>
                            <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
                                <div style={{width:"80%"}}>
                                    <h5 style={{marginTop:30,textAlign:'center',marginBottom:15}}>أسم حامل البطاقة</h5>
                                    <CustomTestField icon={<PersonOutlineIcon sx={{color:"#000000"}}/>} label={"مثال سيف ابراهيم"}/>
                                </div>
                                <div style={{width:"80%"}}>
                                    <h5 style={{marginTop:50,textAlign:'center',marginBottom:15}}>تاريخ انتهاء الصلاحية</h5>
                                    <CustomTestField icon={<CalendarMonthIcon sx={{color:"#000000"}}/>} label={"04/2022"}/>
                                </div>
                                
                            </div>
                            <div style={{flex:0.4,display:'flex',height:'300px',alignItems:'center',justifyContent:'center'}}>
                            <img
                                    src={`${require('../../../assets/imgs/secure_payment.png')}`}
                                    alt={"تسلسل"}
                                    loading="lazy"
                                    width={"100%"}
                                />
                            </div>
                            <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
                                <div style={{width:"80%"}}>
                                    <h5 style={{marginTop:30,textAlign:'center',marginBottom:15}}>رقم البطاقة</h5>
                                    <CustomTestField icon={<PaymentIcon sx={{color:"#000000"}}/>} label={"مثال: 1111 2222 3333 4444"}/>
                                </div>
                                <div style={{width:"80%"}}>
                                    <h5 style={{marginTop:50,textAlign:'center',marginBottom:15}}>الرمز السري</h5>
                                    <CustomTestField icon={<PasswordIcon sx={{color:"#000000"}}/>} label={"مثال: 987"}/>
                                    <span style={{marginTop:5, width:'100%', direction:'ltr',textAlign: 'center',fontSize:'16px',color:'#707070'}}> 
                                    موجود في ظهر البطاقة مكون من 3 أرقام 
                                    </span>
                                </div>
                            </div>

                        </div>
                        <span style={{marginTop:20,marginBottom:30,marginRight:100, width:'100%', direction:'ltr',textAlign: 'right',fontSize:'16px',color:'#707070'}}> ! .جميع المعلومات المقدمة محمية ولا يتم مشاركتها مع اي طرف أخر</span>
                        <Button variant="contained" 
                                sx={{
                                    fontFamily: " 'Tajawal', sans-serif",
                                    backgroundColor: '#2E5266',
                                    color: '#fff',
                                    fontSize: '30px',
                                    marginLeft:'20px',
                                    paddingLeft:5,
                                    paddingRight:5,
                                    height:'50px',
                                    marginBottom:'50px',
                                    flex:1,
                                    '&:hover':{
                                        backgroundColor: '#FFFFFF',
                                        color: '#2E5266',
                                    },
                                    borderRadius: '14px'
                                    }}>
                                    اتمام الدفع
                            </Button>
                    </div>
                    <div onClick={() => goBack()} className="visa-master-payment-dashboard-footer">
                        <div style={{ fontSize: 16,textAlign:'end' }}>الرجوع</div>
                    </div>
                </div>

            );
        } else {
            window.location.href = "/"
        }
    }
}


export default VisaMasterPayment;
